import { Trans } from "@lingui/macro";
import IconPerson from "@mui/icons-material/Person";
import { IApiEpOrganization } from "@smp/api";
import { UiDivider, UiMenu } from "@smp/ui";
import { useCallback } from "react";

import { OrganizationRoleIcon } from "@/components/ui/organization_role_icon";
import { useEpOrganizationOrganizationList } from "@/hooks/use_ep_organization";
import { useContextApp } from "@/screens/app/context/app";

import { MenuItem } from "./menu_item";

export const MenuOrganization = ({
  $anchor,
  marginTop,
  onClose,
  onChange,
}: {
  $anchor: null | HTMLElement;
  marginTop: number;
  onClose: () => void;
  onChange?: (id: IApiEpOrganization["id"] | null) => void;
}) => {
  const {
    actions: { organizationIdChange },
    state: { organizationId },
  } = useContextApp();

  const { organizationList } = useEpOrganizationOrganizationList();

  const handleOrganizationIdChange = useCallback(
    (organizationId: IApiEpOrganization["id"] | null) => {
      onClose();

      if (onChange) {
        onChange(organizationId);
      } else {
        organizationIdChange({ organizationId });
      }
    },
    [onClose, onChange, organizationIdChange],
  );

  return (
    <UiMenu
      anchorEl={$anchor}
      anchorOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
      onClose={onClose}
      open={Boolean($anchor)}
      style={{ marginTop }}
      transformOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
    >
      <MenuItem
        icon={<IconPerson />}
        label={<Trans>Personal Mode</Trans>}
        onClick={handleOrganizationIdChange}
        organizationId={null}
        selected={organizationId === null}
      />
      <UiDivider />
      {organizationList &&
        organizationList.map((organization) => (
          <MenuItem
            disabled={!organization.is_active}
            icon={<OrganizationRoleIcon codename={organization.role} />}
            key={organization.id}
            label={organization.name}
            onClick={handleOrganizationIdChange}
            organizationId={organization.id}
            selected={organization.id === organizationId}
          />
        ))}
    </UiMenu>
  );
};
